module.exports = "/_next/static/images/fe77ebd35919eb40155a7fadc6a7626f-xpeers-lg.jpg.webp";